import {
  Component,
  ElementRef,
  OnInit,
  QueryList,
  ViewChildren,
  ChangeDetectionStrategy
} from '@angular/core';
import { CloudinaryImage } from '@cloudinary/url-gen';
import { CursorService } from 'src/app/services/cursor_animation/cursor.service';

import Splide from '@splidejs/splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';
import { AnimationService } from 'src/app/services/animation/animation.service';

@Component({
  selector: 'app-elites',
  templateUrl: './elites.component.html',
  styleUrls: ['./elites.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ElitesComponent implements OnInit {
  @ViewChildren('textContent') textContent!: QueryList<ElementRef>;
  @ViewChildren('leftReveal') leftReveal!: QueryList<ElementRef>;
  @ViewChildren('rightReveal') rightReveal!: QueryList<ElementRef>;

  elitesImage1 = new CloudinaryImage('elites/s4foxo1guogujzglg9fo', {
    cloudName: 'dv3rvc1by',
  });
  elitesImage2 = new CloudinaryImage('elites/p3uul49lgkexzjwmf4t7', {
    cloudName: 'dv3rvc1by',
  });
  interior1 = new CloudinaryImage('elites/eiasqp6632aviyqrjtbz', {
    cloudName: 'dv3rvc1by',
  });
  interior2 = new CloudinaryImage('elites/qyxuxcno7gem7v3bum71', {
    cloudName: 'dv3rvc1by',
  });
  interior3 = new CloudinaryImage('elites/ofqqhel1e78mfeapeeuv', {
    cloudName: 'dv3rvc1by',
  });
  interior4 = new CloudinaryImage('elites/xsxl0xc414jxtcowrsfg', {
    cloudName: 'dv3rvc1by',
  });
  interior5 = new CloudinaryImage('elites/gj4zrbeyl9olxsmdezg2', {
    cloudName: 'dv3rvc1by',
  });
  interior6 = new CloudinaryImage('elites/hmfgaggdtcykg9irv04m', {
    cloudName: 'dv3rvc1by',
  });
  interior7 = new CloudinaryImage('elites/iwq8hdxzneivq7b4er51', {
    cloudName: 'dv3rvc1by',
  });
  elitesImage3 = new CloudinaryImage('elites/ajxbbqeuqozo5qvzv1na', {
    cloudName: 'dv3rvc1by',
  });
  elitesImage4 = new CloudinaryImage('elites/wt8fesf3nienlptgtths', {
    cloudName: 'dv3rvc1by',
  });
  contactImg = new CloudinaryImage('elites/tspzj7o1ieg67c9bjedr', {
    cloudName: 'dv3rvc1by',
  });

  constructor(
    private cursorService: CursorService,
    private animate: AnimationService
  ) {}

  ngOnInit(): void {
    const splide = new Splide('.splide', {
      type: 'loop',
      drag: 'free',
      focus: 'center',
      perPage: 2,
      arrows: false,
      pagination: false,
      autoScroll: {
        speed: 1,
        pauseOnHover: false,
      },
    });
    splide.mount({ AutoScroll });

    console.log('2nd');
  }

  ngAfterViewInit(): void {
    const elements = this.textContent.toArray().map((el) => el.nativeElement);
    const rightElems = this.rightReveal.toArray().map((el) => el.nativeElement);
    const leftElems = this.leftReveal.toArray().map((el) => el.nativeElement);
    if (elements) {
      this.animate.fadeInElementsImmediate(elements, 0.05);
      console.log('1st');
    }
    this.animate.revelText(leftElems);
    this.animate.revelTextRight(rightElems);
  }

  onMouseEnter(): void {
    this.cursorService.hoverElement();
  }

  onMouseLeave(): void {
    this.cursorService.unhoverElement();
  }

  onMouseColorChange(color: string) {
    this.cursorService.changeCursorColor(color);
  }
  onChangeColorBack(color: string) {
    this.cursorService.changeCursorColorBack(color);
  }
}
